import { isEmbeddedApp } from "lqx-react";

window.addEventListener("message", ({ data }) => {
    if( typeof data === 'object' && data && data.type && eventDispatcher[ data.type ] ){
        eventDispatcher[ data.type ]( data );
    }
});

let setAuthToken : ( token : string ) => void;
let setUserEntitlements : (entitlements: any) => void;

export const parentAuthToken = new Promise<string>(
    resolve => setAuthToken = resolve
);

export const parentUserEntitlements = new Promise<any>(
    resolve => setUserEntitlements = resolve
)

export let parentAuthTokenSync = null;
export let parentUserEntitlementsSync = null;
export let parentPlatformCode = null;

const eventDispatcher = {
    async init({ token, userEntitlements, platformCode }){
        parentAuthTokenSync = token;
        parentPlatformCode = platformCode;
        await authEventsQueue.trigger({
            type: 'authenticated',
            token 
        });
        
        setAuthToken( token );

        const userEntitlementsJson = JSON.parse(userEntitlements);
        setUserEntitlements(parentUserEntitlementsSync = userEntitlementsJson);

        localStorage.setItem('platformCode', platformCode);
    }
}

export function getAuthToken(){
    return isEmbeddedApp() ?
        parentAuthTokenSync : 
        localStorage.getItem('token');
}

export function getGeneralPlatformCode(){
    return isEmbeddedApp() ?
        parentPlatformCode : 
        localStorage.getItem('platformCode');
}

export type AsyncEventHandler = ( ...args : any[] ) => Promise<void>
export class AsyncEventQueue {
    private handlers : AsyncEventHandler[] = []
    
    async trigger( a? : any, b? : any, c? : any, d? : any, e? : any ){
        return ( Promise as any ).allSettled(
            this.handlers.map( x => x( a, b, c, d, e ) )
        )
    }

    on( handler : AsyncEventHandler ){
        this.handlers.push( handler );

        return handler;
    }

    off( handler : AsyncEventHandler ){
        this.handlers = this.handlers.filter( x => x !== handler );   
    }

    dispose(){
        this.handlers = [];       
    }
}

export const authEventsQueue = new AsyncEventQueue();